import { Typography } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";

const MostrarMais = ({ paginas, pagina, nextPage }) => {

  return (
    <div className="flex w-full justify-center">
      {pagina < paginas &&
        <XAPPButton
          type="Button"
          className="text-white text-initial"
          variant="outlined"
          color="primary"
          onClick={() => nextPage()}
          iconProps={"mr-8"}
          icon={"add"}
          label={"Mostrar mais"}
        />
      }
    </div>
  )
};

export default MostrarMais;